module.exports = __webpack_public_path__ + "img/37800.652926b1.jpg";